import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadDataSourceStatus';
export const dataSourceStatusActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
const dataSourceStatusPrefix = 'dataSourceStatus';
export const dataSourceStatusConstants = {
    SETDATASOURCESTATUS: `${dataSourceStatusPrefix}/SETDATASOURCESTATUS`,
};
const setDataSourceStatusPayload = (state, actionResult) => {
    return {
        ...state,
        items: actionResult.payload,
    };
};
export function setDataSourceStatus(dataSourceStatus) {
    return {
        type: dataSourceStatusConstants.SETDATASOURCESTATUS,
        payload: dataSourceStatus.items,
    };
}
// Action Creators
export const dataSourceStatusLoadAction = (workspaceId, dataSourceName, dataSourceVersion) => {
    return {
        type: dataSourceStatusActionTypes.LOAD,
        payload: { workspaceId: workspaceId, dataSourceName: dataSourceName, dataSourceVersion: dataSourceVersion },
    };
};
export const dataSourceStatusLoadingAction = (payload) => {
    return {
        type: dataSourceStatusActionTypes.LOADING,
        payload: payload,
    };
};
export const dataSourceStatusLoadedAction = (payload, result) => {
    return {
        type: dataSourceStatusActionTypes.LOADED,
        payload: {
            items: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case dataSourceStatusConstants.SETDATASOURCESTATUS:
            return setDataSourceStatusPayload(state, action);
        case dataSourceStatusActionTypes.LOADING:
            return {
                ...state,
                items: {
                    ...state.items,
                    status: AsyncRequestStatus.Pending,
                },
            };
        case dataSourceStatusActionTypes.LOADED:
            const loadedAction = action;
            return {
                ...state,
                items: loadedAction.payload.items,
            };
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=DataSourceDetailStatus.ducks.js.map
